import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import RocketLaunchOutlinedIcon from '@mui/icons-material/RocketLaunchOutlined';
import useSelectedCompany from './useSelectedCompany';

const useCessionTypeOptions = (selectedProvider, allDocumentsHaveXML) => {
  const { t } = useTranslation();
  const company = useSelectedCompany();
  const { hasDigitalCertificate, invoiceProviderCredentials = [] } = company;

  const hasInvoiceProviderCredentials = useMemo(() => {
    if (!selectedProvider || !selectedProvider.id) return false;

    return invoiceProviderCredentials.some(
      (credential) => credential.credentialProvider.id === selectedProvider.id,
    );
  }, [invoiceProviderCredentials, selectedProvider]);

  const options = useMemo(() => {
    if (!selectedProvider) {
      return [];
    }

    const { name, iconUrl, integrated } = selectedProvider;

    const subItems = [
      {
        id: 1,
        text: 'Subir Certificado Digital',
        checked: hasDigitalCertificate,
      },
    ];

    if (name !== 'MiPyme') {
      if (integrated) {
        subItems.push({
          id: 2,
          text: 'Ingresar credenciales de tu facturador',
          checked: hasInvoiceProviderCredentials,
        });
      } else {
        subItems.push({
          id: 2,
          text: 'Subir XML de tus facturas',
          checked: allDocumentsHaveXML,
        });
      }
    }

    return [
      {
        value: 'internal',
        label: t('internal-cession-label'),
        src: t('internal-cession-image'),
        altIcon: RocketLaunchOutlinedIcon,
        iconSx: { color: 'gray.A400', fontSize: { xs: 22, md: 36 } },
        description: t('internal-cession-description'),
        recommended: true,
        subItems,
        footer:
          '(Tus credenciales están encriptadas, siempre estarán seguras con nosotros).',
      },
      {
        value: 'external',
        label: t('external-cession-label'),
        src: iconUrl,
        description: 'Cesión manual desde tu facturador',
      },
    ];
  }, [selectedProvider, hasDigitalCertificate, hasInvoiceProviderCredentials]);

  return options;
};

export default useCessionTypeOptions;
